var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.76667C1 4.27319 1 3.52646 1.29065 2.95603C1.54631 2.45426 1.95426 2.04631 2.45603 1.79065C3.02646 1.5 3.77319 1.5 5.26667 1.5H12.7333C14.2268 1.5 14.9735 1.5 15.544 1.79065C16.0457 2.04631 16.4537 2.45426 16.7094 2.95603C17 3.52646 17 4.27319 17 5.76667V13.2333C17 14.7268 17 15.4735 16.7094 16.044C16.4537 16.5457 16.0457 16.9537 15.544 17.2094C14.9735 17.5 14.2268 17.5 12.7333 17.5H5.26667C3.77319 17.5 3.02646 17.5 2.45603 17.2094C1.95426 16.9537 1.54631 16.5457 1.29065 16.044C1 15.4735 1 14.7268 1 13.2333V5.76667Z",
    stroke: "#808991",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckEmpty);
export default __webpack_public_path__ + "static/media/ic_check_empty.32ac328389ed4dd7a6eb418a201f34c7.svg";
export { ForwardRef as ReactComponent };